var voted_users_default = {
  "container": "F4agS",
  "webview": "FLX-D",
  "avatar_list": "zzr3d",
  "avatar": "a5Pb-",
  "user_avatar": "_0Y520",
  "modal": "OevGT",
  "voted_users_modal": "UKVjk",
  "overlay": "_2cPUH",
  "user_card": "Gq4Oy",
  "user_name": "mWUlq",
  "voted_users_modal_header": "TxZMD",
  "cta": "UuMr5",
  "close_icon": "-NFn1",
  "title": "B-LAO",
  "member_list_container": "-jRs0",
  "member_list": "j2Mri",
  "loader": "Nc6nu",
  "anonymous_counter": "_73Nwn",
  "spinner": "GI-HI",
  "spin": "_6io-F"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
